import { render, staticRenderFns } from "./ActionFavorite.vue?vue&type=template&id=dacc71da"
import script from "./ActionFavorite.vue?vue&type=script&lang=js"
export * from "./ActionFavorite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports